import React from 'react';

export default function ProductRangeFilter({ label, from, to, onFromChange, onToChange, max }) {
  const invalid =
    (from !== '' && to !== '' && Number(from) > Number(to)) ||
    [from, to].some(
      value => value !== '' && (Number(value) < 0 || (max != null && Number(value) > max)),
    );
  return (
    <fieldset className='ap-range'>
      <legend>{label}</legend>
      <div>
        <input
          className={`form-control form-control-sm${invalid ? ' is-invalid' : ''}`}
          type='number'
          min='0'
          max={max}
          step='1'
          placeholder='Від'
          aria-label={`${label} від`}
          aria-invalid={invalid}
          value={from}
          onChange={event => onFromChange(event.target.value)}
        />
        <input
          className={`form-control form-control-sm${invalid ? ' is-invalid' : ''}`}
          type='number'
          min='0'
          max={max}
          step='1'
          placeholder='До'
          aria-label={`${label} до`}
          aria-invalid={invalid}
          value={to}
          onChange={event => onToChange(event.target.value)}
        />
      </div>
      {invalid && (
        <small className='text-danger'>
          Перевірте межі діапазону{max != null ? ` (0–${max})` : ''}
        </small>
      )}
    </fieldset>
  );
}
